import React from "react";
import { Box, Typography, Divider, Paper, Container } from "@mui/material";
import LatestImage from "../components/LatestImage";
import DailyImages from "../components/DailyImages";

const HomePage = () => {
  return (
    <Container maxWidth='lg'>
      <Box sx={{ py: 3 }}>
        <Paper sx={{ p: 3, mb: 4, textAlign: "center" }}>
          <Typography variant='h4' component='h1' gutterBottom>
            Webcam Viewer
          </Typography>
          <Typography variant='body1' color='text.secondary'>
            View the latest webcam images from the Modellflugplatz. Images are
            updated every 5 minutes.
          </Typography>
        </Paper>

        {/* Latest Image Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant='h5' component='h2' gutterBottom>
            Latest Image
          </Typography>
          <LatestImage />
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Daily Images Section */}
        <DailyImages />
      </Box>
    </Container>
  );
};

export default HomePage;
